import { render } from "./StatusTabs.vue?vue&type=template&id=3e9666dc&scoped=true"
import script from "./StatusTabs.vue?vue&type=script&lang=js"
export * from "./StatusTabs.vue?vue&type=script&lang=js"

import "./StatusTabs.vue?vue&type=style&index=0&id=3e9666dc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9666dc"]])

export default __exports__